import React, { memo, useCallback } from "react";
import { useHomeData } from "../../../contexts/HomeDataContext";
import { IReferral, ProgressState } from "../../../interfaces/home";
import ReferralsShimmer from "./ReferralsShimmer";
import { ErrorComponent } from "../../errorComponent";
import ReferralsSuccessView from "./ReferralsSuccessView";
import { isValidData } from "utils/object";

const Referrals = () => {
    const { referrals, retryReferrals } = useHomeData();
    const { state, data } = referrals;

    const getStateToRender = useCallback(() => {
        switch (state) {
            case ProgressState.IN_PROGRESS:
                return <ReferralsShimmer />;
            case ProgressState.COMPLETED:
                if (!isValidData(data)) {
                    return null;
                }
                return <ReferralsSuccessView referrals={data as IReferral[]} />;
            case ProgressState.FAILED:
                return <ErrorComponent onRetry={retryReferrals} />;
            default:
                return null;
        }
    }, [state, data, retryReferrals]);

    return getStateToRender();
};

export default memo(Referrals);
